const Main = () => import('@/modules/RemoteStore/view/Layout.vue');
// const Shell = () => import('@/modules/RemoteStore/view/Layout.vue');


export default [
  {
    path: '/r/o/:id',
    name: 'order-public-view',
    component: Main,
    // redirect: {
    //   name: 'view-invoiced'
    // },
    // children: [
    //   {
    //     path: '/o/:id',
    //     name: 'view-remote-public',
    //     component: Shell,
    //     meta: {
    //       public: true
    //     }
    //   },
    // ],
  },
]